import React, { Component, createRef } from "react";
import SettingsModal from "./settings_modal";
import CreateUserModal from "./create_user_modal";
import { Link } from "react-router-dom";

class Header extends Component {
  state = {
    showModal: false,
    showUserModal: false,
    showProfilePopup: false, // ✅ NEW
  };

  profileRef = createRef(); // ✅ NEW (for outside click)

  toggleModal = () => {
    this.setState((prev) => ({ showModal: !prev.showModal }));
  };

  toggleUserModal = () => {
    this.setState((prev) => ({ showUserModal: !prev.showUserModal }));
  };

  toggleProfilePopup = () => {
    this.setState((prev) => ({ showProfilePopup: !prev.showProfilePopup }));
  };

  handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.profileRef.current &&
      !this.profileRef.current.contains(event.target)
    ) {
      this.setState({ showProfilePopup: false });
    }
  };

  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    const isAdmin = user && user.role === 1;
    const isSuperAdmin = user && user.role === 0;

    return (
      <>
        <div className="d-flex justify-content-between align-items-center px-3 px-md-5 py-3 py-md-3 border-bottom bg-primary-blue text-white">
          {/* Logo */}
          <div className="mb-2 mb-md-0">
            <Link to="/">
              <img
                src="/bhepl_logo.webp"
                alt="BHEPL Logo"
                className="img-fluid"
                style={{
                  height: "clamp(30px, 5vw, 50px)",
                }}
              />
            </Link>
          </div>

          {/* Title (Desktop) */}
          <h5
            className="text-center flex-grow-1 fw-bold m-0 d-none d-md-block"
            style={{
              fontSize: "clamp(1rem, 2vw, 1.5rem)",
            }}
          >
            DESIGN AUTOMATION TOOL
          </h5>

          {/* Title (Mobile) */}
          <div className="w-25 d-md-none text-center mb-2">
            <h6
              className="fw-bold m-0"
              style={{
                fontSize: "clamp(1rem, 4vw, 1.25rem)",
              }}
            >
              DESIGN AUTOMATION TOOL
            </h6>
          </div>


          {/* Station Info Button */}
          <Link to="/station-info">
            <button
              className="btn text-white p-2 p-sm-2 p-md-3"
              style={{ fontSize: "clamp(0.9rem, 1.5vw, 1rem)" }}
            >
              <div className="d-flex align-items-center gap-1">
                <i
                  className="bi bi-file-earmark-text"
                  title="Settings"
                  style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)" }}
                ></i>
                <span className="d-none d-sm-inline">Station Info Files</span>
              </div>
            </button>
          </Link>


          {/* ✅ Profile Button + Popup */}
          <div className="ms-2 position-relative" ref={this.profileRef}>
            <button
              className="btn text-white p-2 p-sm-2 p-md-3"
              type="button"
              onClick={this.toggleProfilePopup}
              style={{ fontSize: "clamp(0.9rem, 1.5vw, 1rem)" }}
            >
              <div className="d-flex align-items-center gap-1">
                <i
                  className="bi bi-person-circle"
                  style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)" }}
                ></i>
                <span className="d-none d-sm-inline">Profile</span>
              </div>
            </button>

            {/* ✅ Popup Below Button */}
            {this.state.showProfilePopup && (
              <div
                className="bg-white text-dark shadow rounded"
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  marginTop: "8px",
                  width: "260px",
                  zIndex: 9999,
                  overflow: "hidden",
                }}
              >
                {/* User Info */}
                <div className="px-3 py-2 border-bottom">
                  <div className="fw-bold">{user?.name || "User"}</div>
                  <div className="small text-muted">{user?.email || "-"}</div>
                </div>

                {/* Admin: Add User */}
                {isAdmin && (
                  <button
                    className="w-100 btn text-start px-3 py-2"
                    style={{ borderRadius: 0 }}
                    onClick={() => {
                      this.toggleUserModal();
                      this.setState({ showProfilePopup: false });
                    }}
                  >
                    <i className="bi bi-person-plus-fill me-2"></i>
                    Add User
                  </button>
                )}
                {isSuperAdmin && (
                  <Link className="w-100 btn text-start px-3 py-2" to="/admin" onClick={() => this.setState({ showProfilePopup: false })}>
                    <i className="bi bi-shield-lock-fill me-2"></i>
                    Admin Console
                  </Link>
                )}

                {/* Logout */}
                <button
                  className="w-100 btn text-start px-3 py-2 text-danger"
                  style={{ borderRadius: 0 }}
                  onClick={this.handleLogout}
                >
                  <i className="bi bi-box-arrow-right me-2"></i>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Modals */}
        {this.state.showUserModal && (
          <CreateUserModal closeModal={this.toggleUserModal} />
        )}
        {this.state.showModal && (
          <SettingsModal closeModal={this.toggleModal} />
        )}
      </>
    );
  }
}

export default Header;
